const compareIconNames = [
  { v4: 'address-book-o', v5: 'address-book' },
  { v4: 'address-card-o', v5: 'address-card' },
  { v4: 'area-chart', v5: 'chart-area' },
  { v4: 'arrow-circle-o-down', v5: 'arrow-alt-circle-down' },
  { v4: 'arrow-circle-o-left', v5: 'arrow-alt-circle-left' },
  { v4: 'arrow-circle-o-right', v5: 'arrow-alt-circle-right' },
  { v4: 'arrow-circle-o-up', v5: 'arrow-alt-circle-up' },
  { v4: 'arrows', v5: 'arrows-alt' },
  { v4: 'arrows-alt', v5: 'expand-arrows-alt' },
  { v4: 'arrows-h', v5: 'arrows-alt-h' },
  { v4: 'arrows-v', v5: 'arrows-alt-v' },
  { v4: 'asl-interpreting', v5: 'american-sign-language-interpreting' },
  { v4: 'automobile', v5: 'car' },
  { v4: 'bank', v5: 'university' },
  { v4: 'bar-chart', v5: 'chart-bar' },
  { v4: 'bar-chart-o', v5: 'chart-bar' },
  { v4: 'bathtub', v5: 'bath' },
  { v4: 'battery', v5: 'battery-full' },
  { v4: 'battery-0', v5: 'battery-empty' },
  { v4: 'battery-1', v5: 'battery-quarter' },
  { v4: 'battery-2', v5: 'battery-half' },
  { v4: 'battery-3', v5: 'battery-three-quarters' },
  { v4: 'battery-4', v5: 'battery-full' },
  { v4: 'bell-o', v5: 'bell' },
  { v4: 'bell-slash-o', v5: 'bell-slash' },
  { v4: 'bookmark-o', v5: 'bookmark' },
  { v4: 'building-o', v5: 'building' },
  { v4: 'cab', v5: 'taxi' },
  { v4: 'calendar', v5: 'calendar-alt' },
  { v4: 'calendar-check-o', v5: 'calendar-check' },
  { v4: 'calendar-minus-o', v5: 'calendar-minus' },
  { v4: 'calendar-o', v5: 'calendar' },
  { v4: 'calendar-plus-o', v5: 'calendar-plus' },
  { v4: 'calendar-times-o', v5: 'calendar-times' },
  { v4: 'caret-square-o-down', v5: 'caret-square-down' },
  { v4: 'caret-square-o-left', v5: 'caret-square-left' },
  { v4: 'caret-square-o-right', v5: 'caret-square-right' },
  { v4: 'caret-square-o-up', v5: 'caret-square-up' },
  { v4: 'cc', v5: 'closed-captioning' },
  { v4: 'chain', v5: 'link' },
  { v4: 'chain-broken', v5: 'unlink' },
  { v4: 'check-circle-o', v5: 'check-circle' },
  { v4: 'check-square-o', v5: 'check-square' },
  { v4: 'circle-o', v5: 'circle' },
  { v4: 'circle-o-notch', v5: 'circle-notch' },
  { v4: 'circle-thin', v5: 'circle' },
  { v4: 'clipboard', v5: 'clipboard' },
  { v4: 'clock-o', v5: 'clock' },
  { v4: 'clone', v5: 'clone' },
  { v4: 'close', v5: 'times' },
  { v4: 'cloud-download', v5: 'cloud-download-alt' },
  { v4: 'cloud-upload', v5: 'cloud-upload-alt' },
  { v4: 'cny', v5: 'yen-sign' },
  { v4: 'code-fork', v5: 'code-branch' },
  { v4: 'comment-o', v5: 'comment' },
  { v4: 'commenting', v5: 'comment-dots' },
  { v4: 'commenting-o', v5: 'comment-dots' },
  { v4: 'comments-o', v5: 'comments' },
  { v4: 'compass', v5: 'compass' },
  { v4: 'copyright', v5: 'copyright' },
  { v4: 'credit-card', v5: 'credit-card' },
  { v4: 'credit-card-alt', v5: 'credit-card' },
  { v4: 'cutlery', v5: 'utensils' },
  { v4: 'dashboard', v5: 'tachometer-alt' },
  { v4: 'deafness', v5: 'deaf' },
  { v4: 'dedent', v5: 'outdent' },
  { v4: 'diamond', v5: 'gem' },
  { v4: 'dollar', v5: 'dollar-sign' },
  { v4: 'dot-circle-o', v5: 'dot-circle' },
  { v4: 'drivers-license', v5: 'id-card' },
  { v4: 'drivers-license-o', v5: 'id-card' },
  { v4: 'envelope-o', v5: 'envelope' },
  { v4: 'envelope-open-o', v5: 'envelope-open' },
  { v4: 'eur', v5: 'euro-sign' },
  { v4: 'euro', v5: 'euro-sign' },
  { v4: 'exchange', v5: 'exchange-alt' },
  { v4: 'external-link', v5: 'external-link-alt' },
  { v4: 'external-link-square', v5: 'external-link-square-alt' },
  { v4: 'eye', v5: 'eye' },
  { v4: 'eye-slash', v5: 'eye-slash' },
  { v4: 'eyedropper', v5: 'eye-dropper' },
  { v4: 'feed', v5: 'rss' },
  { v4: 'file-archive-o', v5: 'file-archive' },
  { v4: 'file-audio-o', v5: 'file-audio' },
  { v4: 'file-code-o', v5: 'file-code' },
  { v4: 'file-excel-o', v5: 'file-excel' },
  { v4: 'file-image-o', v5: 'file-image' },
  { v4: 'file-movie-o', v5: 'file-video' },
  { v4: 'file-o', v5: 'file' },
  { v4: 'file-pdf-o', v5: 'file-pdf' },
  { v4: 'file-photo-o', v5: 'file-image' },
  { v4: 'file-picture-o', v5: 'file-image' },
  { v4: 'file-powerpoint-o', v5: 'file-powerpoint' },
  { v4: 'file-sound-o', v5: 'file-audio' },
  { v4: 'file-text', v5: 'file-alt' },
  { v4: 'file-text-o', v5: 'file-alt' },
  { v4: 'file-video-o', v5: 'file-video' },
  { v4: 'file-word-o', v5: 'file-word' },
  { v4: 'file-zip-o', v5: 'file-archive' },
  { v4: 'files-o', v5: 'copy' },
  { v4: 'flag-o', v5: 'flag' },
  { v4: 'flash', v5: 'bolt' },
  { v4: 'floppy-o', v5: 'save' },
  { v4: 'folder-o', v5: 'folder' },
  { v4: 'folder-open-o', v5: 'folder-open' },
  { v4: 'frown-o', v5: 'frown' },
  { v4: 'futbol-o', v5: 'futbol' },
  { v4: 'gbp', v5: 'pound-sign' },
  { v4: 'gear', v5: 'cog' },
  { v4: 'gears', v5: 'cogs' },
  { v4: 'glass', v5: 'glass-martini' },
  { v4: 'group', v5: 'users' },
  { v4: 'hand-grab-o', v5: 'hand-rock' },
  { v4: 'hand-lizard-o', v5: 'hand-lizard' },
  { v4: 'hand-o-down', v5: 'hand-point-down' },
  { v4: 'hand-o-left', v5: 'hand-point-left' },
  { v4: 'hand-o-right', v5: 'hand-point-right' },
  { v4: 'hand-o-up', v5: 'hand-point-up' },
  { v4: 'hand-paper-o', v5: 'hand-paper' },
  { v4: 'hand-peace-o', v5: 'hand-peace' },
  { v4: 'hand-pointer-o', v5: 'hand-pointer' },
  { v4: 'hand-rock-o', v5: 'hand-rock' },
  { v4: 'hand-scissors-o', v5: 'hand-scissors' },
  { v4: 'hand-spock-o', v5: 'hand-spock' },
  { v4: 'hand-stop-o', v5: 'hand-paper' },
  { v4: 'handshake-o', v5: 'handshake' },
  { v4: 'hard-of-hearing', v5: 'deaf' },
  { v4: 'hdd-o', v5: 'hdd' },
  { v4: 'header', v5: 'heading' },
  { v4: 'heart-o', v5: 'heart' },
  { v4: 'hospital-o', v5: 'hospital' },
  { v4: 'hotel', v5: 'bed' },
  { v4: 'hourglass-1', v5: 'hourglass-start' },
  { v4: 'hourglass-2', v5: 'hourglass-half' },
  { v4: 'hourglass-3', v5: 'hourglass-end' },
  { v4: 'hourglass-o', v5: 'hourglass' },
  { v4: 'id-badge', v5: 'id-badge' },
  { v4: 'id-card-o', v5: 'id-card' },
  { v4: 'ils', v5: 'shekel-sign' },
  { v4: 'image', v5: 'image' },
  { v4: 'inr', v5: 'rupee-sign' },
  { v4: 'institution', v5: 'university' },
  { v4: 'intersex', v5: 'transgender' },
  { v4: 'jpy', v5: 'yen-sign' },
  { v4: 'keyboard-o', v5: 'keyboard' },
  { v4: 'krw', v5: 'won-sign' },
  { v4: 'legal', v5: 'gavel' },
  { v4: 'lemon-o', v5: 'lemon' },
  { v4: 'level-down', v5: 'level-down-alt' },
  { v4: 'level-up', v5: 'level-up-alt' },
  { v4: 'life-bouy', v5: 'life-ring' },
  { v4: 'life-buoy', v5: 'life-ring' },
  { v4: 'life-ring', v5: 'life-ring' },
  { v4: 'life-saver', v5: 'life-ring' },
  { v4: 'lightbulb-o', v5: 'lightbulb' },
  { v4: 'line-chart', v5: 'chart-line' },
  { v4: 'list-alt', v5: 'list-alt' },
  { v4: 'long-arrow-down', v5: 'long-arrow-alt-down' },
  { v4: 'long-arrow-left', v5: 'long-arrow-alt-left' },
  { v4: 'long-arrow-right', v5: 'long-arrow-alt-right' },
  { v4: 'long-arrow-up', v5: 'long-arrow-alt-up' },
  { v4: 'mail-forward', v5: 'share' },
  { v4: 'mail-reply', v5: 'reply' },
  { v4: 'mail-reply-all', v5: 'reply-all' },
  { v4: 'map-marker', v5: 'map-marker-alt' },
  { v4: 'map-o', v5: 'map' },
  { v4: 'meh-o', v5: 'meh' },
  { v4: 'minus-square-o', v5: 'minus-square' },
  { v4: 'mobile', v5: 'mobile-alt' },
  { v4: 'mobile-phone', v5: 'mobile-alt' },
  { v4: 'money', v5: 'money-bill-alt' },
  { v4: 'moon-o', v5: 'moon' },
  { v4: 'mortar-board', v5: 'graduation-cap' },
  { v4: 'navicon', v5: 'bars' },
  { v4: 'newspaper-o', v5: 'newspaper' },
  { v4: 'object-group', v5: 'object-group' },
  { v4: 'object-ungroup', v5: 'object-ungroup' },
  { v4: 'paper-plane-o', v5: 'paper-plane' },
  { v4: 'paste', v5: 'clipboard' },
  { v4: 'pause-circle-o', v5: 'pause-circle' },
  { v4: 'pencil', v5: 'pencil-alt' },
  { v4: 'pencil-square', v5: 'pen-square' },
  { v4: 'pencil-square-o', v5: 'edit' },
  { v4: 'photo', v5: 'image' },
  { v4: 'picture-o', v5: 'image' },
  { v4: 'pie-chart', v5: 'chart-pie' },
  { v4: 'play-circle-o', v5: 'play-circle' },
  { v4: 'plus-square-o', v5: 'plus-square' },
  { v4: 'question-circle-o', v5: 'question-circle' },
  { v4: 'refresh', v5: 'sync' },
  { v4: 'registered', v5: 'registered' },
  { v4: 'remove', v5: 'times' },
  { v4: 'reorder', v5: 'bars' },
  { v4: 'repeat', v5: 'redo' },
  { v4: 'rmb', v5: 'yen-sign' },
  { v4: 'rotate-left', v5: 'undo' },
  { v4: 'rotate-right', v5: 'redo' },
  { v4: 'rouble', v5: 'ruble-sign' },
  { v4: 'rub', v5: 'ruble-sign' },
  { v4: 'ruble', v5: 'ruble-sign' },
  { v4: 'rupee', v5: 'rupee-sign' },
  { v4: 's15', v5: 'bath' },
  { v4: 'scissors', v5: 'cut' },
  { v4: 'send', v5: 'paper-plane' },
  { v4: 'send-o', v5: 'paper-plane' },
  { v4: 'share-square-o', v5: 'share-square' },
  { v4: 'shekel', v5: 'shekel-sign' },
  { v4: 'sheqel', v5: 'shekel-sign' },
  { v4: 'shield', v5: 'shield-alt' },
  { v4: 'sign-in', v5: 'sign-in-alt' },
  { v4: 'sign-out', v5: 'sign-out-alt' },
  { v4: 'signing', v5: 'sign-language' },
  { v4: 'sliders', v5: 'sliders-h' },
  { v4: 'smile-o', v5: 'smile' },
  { v4: 'snowflake-o', v5: 'snowflake' },
  { v4: 'soccer-ball-o', v5: 'futbol' },
  { v4: 'sort-alpha-asc', v5: 'sort-alpha-down' },
  { v4: 'sort-alpha-desc', v5: 'sort-alpha-up' },
  { v4: 'sort-amount-asc', v5: 'sort-amount-down' },
  { v4: 'sort-amount-desc', v5: 'sort-amount-up' },
  { v4: 'sort-asc', v5: 'sort-up' },
  { v4: 'sort-desc', v5: 'sort-down' },
  { v4: 'sort-numeric-asc', v5: 'sort-numeric-down' },
  { v4: 'sort-numeric-desc', v5: 'sort-numeric-up' },
  { v4: 'spoon', v5: 'utensil-spoon' },
  { v4: 'square-o', v5: 'square' },
  { v4: 'star-half-empty', v5: 'star-half' },
  { v4: 'star-half-full', v5: 'star-half' },
  { v4: 'star-half-o', v5: 'star-half' },
  { v4: 'star-o', v5: 'star' },
  { v4: 'sticky-note-o', v5: 'sticky-note' },
  { v4: 'stop-circle-o', v5: 'stop-circle' },
  { v4: 'sun-o', v5: 'sun' },
  { v4: 'support', v5: 'life-ring' },
  { v4: 'tablet', v5: 'tablet-alt' },
  { v4: 'tachometer', v5: 'tachometer-alt' },
  { v4: 'television', v5: 'tv' },
  { v4: 'thermometer', v5: 'thermometer-full' },
  { v4: 'thermometer-0', v5: 'thermometer-empty' },
  { v4: 'thermometer-1', v5: 'thermometer-quarter' },
  { v4: 'thermometer-2', v5: 'thermometer-half' },
  { v4: 'thermometer-3', v5: 'thermometer-three-quarters' },
  { v4: 'thermometer-4', v5: 'thermometer-full' },
  { v4: 'thumb-tack', v5: 'thumbtack' },
  { v4: 'thumbs-o-down', v5: 'thumbs-down' },
  { v4: 'thumbs-o-up', v5: 'thumbs-up' },
  { v4: 'ticket', v5: 'ticket-alt' },
  { v4: 'times-circle-o', v5: 'times-circle' },
  { v4: 'times-rectangle', v5: 'window-close' },
  { v4: 'times-rectangle-o', v5: 'window-close' },
  { v4: 'toggle-down', v5: 'caret-square-down' },
  { v4: 'toggle-left', v5: 'caret-square-left' },
  { v4: 'toggle-right', v5: 'caret-square-right' },
  { v4: 'toggle-up', v5: 'caret-square-up' },
  { v4: 'trash', v5: 'trash-alt' },
  { v4: 'trash-o', v5: 'trash-alt' },
  { v4: 'try', v5: 'lira-sign' },
  { v4: 'turkish-lira', v5: 'lira-sign' },
  { v4: 'unsorted', v5: 'sort' },
  { v4: 'usd', v5: 'dollar-sign' },
  { v4: 'user-circle-o', v5: 'user-circle' },
  { v4: 'user-o', v5: 'user' },
  { v4: 'vcard', v5: 'address-card' },
  { v4: 'vcard-o', v5: 'address-card' },
  { v4: 'video-camera', v5: 'video' },
  { v4: 'volume-control-phone', v5: 'phone-volume' },
  { v4: 'warning', v5: 'exclamation-triangle' },
  { v4: 'window-close-o', v5: 'window-close' },
  { v4: 'window-maximize', v5: 'window-maximize' },
  { v4: 'window-restore', v5: 'window-restore' },
  { v4: 'won', v5: 'won-sign' },
  { v4: 'yen', v5: 'yen-sign' },
];

export default compareIconNames;
